import { PublicLayout } from '../components/Layout/PublicLayout'
import { useBrandName } from '@jotta/grpc-connect-client/config'

import WelcomePng from './welcome.png'
import { RouterLink } from '@jotta/ui/RouterLink'
import { LoadingOverlay } from '@jotta/ui/LoadingOverlay'
import { Trans } from '@lingui/macro'

export function SignupAccepted() {
  const brandName = useBrandName()
  if (!brandName) {
    return <LoadingOverlay />
  }
  return (
    <PublicLayout
      section="signupaccepted"
      className="mx-auto flex max-w-xl flex-col items-center gap-4 py-8 text-center"
    >
      <h1 className="title-lg">
        <Trans>Welcome to {brandName}!</Trans>
      </h1>
      <img src={WelcomePng} className="h-80" />
      <p>
        <Trans>
          Congratulations on your new subscription! You will shortly receive a
          payment receipt by email.
        </Trans>
      </p>
      <RouterLink to="/download" variant="links.text">
        <Trans>Continue to the download page.</Trans>
      </RouterLink>
    </PublicLayout>
  )
}
